(ns hai.ui.components.link
  (:require
   [lambdaisland.ornament :as o]))

(o/defstyled a :a
  "Basic link styled to at least resemble a plain HTML link, with hover/active
  states and a pointer cursor"
  :text-primary
  :underline
  :cursor-pointer
  [:&:hover {:filter "brightness(80%)"}]
  [:&:active {:filter "brightness(110%)"}])

(o/defstyled link :a
  "Link based on radix color tokens, plays well with light/dark mode"
  :underline
  :cursor-pointer
  {:color "var(--accent-a9)"}
  [:&:hover {:color "var(--accent-a8)"}]
  [:&:active {:color "var(--accent-a10)"}])

(o/defstyled faded link
  "Subdued gray link"
  {:color "var(--gray-9)"}
  [:&:hover {:color "var(--gray-8)"}]
  [:&:active {:color "var(--gray-10)"}])
